/**
 * Body of the return address card: the shared address form with the warehouse's wording and the
 * company name the label carries, above the offer to keep the corrected address on the return
 * method instead of only on this parcel.
 */
import { observer } from "mobx-react";
import { Checkbox } from "../../../../../../../../components/inputs/checkbox/checkbox";
import ListLayout, { LIST_LAYOUT_SPACING_VARIANT } from "../../../../../../../../components/layouts/list-layout/list-layout";
import ShipmentAddressForm from "../../../shared/shipment-address-form/shipment-address-form";
import { IValidateShippingDetailsProps } from "../validate-shipping-details-props";

/** Naming the method matters: the merchant is about to change a setting other RMAs are labelled from. */
const saveAddressLabel = (returnMethodName: string | undefined): string => (
    returnMethodName
        ? `Update these changes in the return method (${returnMethodName})`
        : "Update these changes in the return method"
);

const ReturnAddress: React.FC<IValidateShippingDetailsProps> = observer(({ store, validationGroup }) => (
    <ListLayout spacingVariant={LIST_LAYOUT_SPACING_VARIANT.SMAll}>
        <ShipmentAddressForm
            store={store.returnAddress}
            validationGroup={validationGroup}
            nameLabel="Address name"
            showCompany
        />

        <Checkbox
            label={saveAddressLabel(store.returnMethodName)}
            checked={store.shouldSaveReturnAddress}
            onChange={store.setShouldSaveReturnAddress}
        />
    </ListLayout>
));

export default ReturnAddress;
